<base-wrapper
  [ngClass]="{ 'customized-user': isCustomizedUser }"
  [logo]="logo"
  [logoSmall]="logoSmall"
  [applicationSections]="sections"
  [userMenu]="userMenu"
></base-wrapper>
